/**
 * Store Zustand para filtros de Processos
 * Equivalente ao useUnidadesFilters, mas para a view de Processos
 */
import { create } from 'zustand';

const DEFAULT_SUPPLIERS = [
  'Equipe Ativa Gestão | AVCB',
  'Equipe Ativa Gestão | Alvarás e Licenças',
  'Equipe MS Consultoria',
];

interface ProcessosFiltersState {
  // Filtros de Regional/UF
  regional: string | null;
  uf: string | null;
  
  // Filtros específicos de processos
  docTypes: string[] | null;
  
  // Filtros específicos do gráfico de pendências
  pendencyTypes: string[] | null;
  suppliers: string[] | null;
  
  // Actions
  setRegional: (regional: string | null) => void;
  setUF: (uf: string | null) => void;
  setDocTypes: (docTypes: string[] | null) => void;
  setPendencyTypes: (pendencyTypes: string[] | null) => void;
  setSuppliers: (suppliers: string[] | null) => void;
  clearFilters: () => void;
  clearPendencyFilters: () => void;
  
  // Helper para montar query params
  getFilterParams: () => Record<string, string>;
}

export const useProcessosFilters = create<ProcessosFiltersState>((set, get) => ({
  // Estado inicial
  regional: null,
  uf: null,
  docTypes: null,
  pendencyTypes: null,
  suppliers: DEFAULT_SUPPLIERS,
  
  // Actions
  setRegional: (regional) => set({ regional, uf: null }), // Limpar UF quando regional é definida
  setUF: (uf) => set({ uf }),
  setDocTypes: (docTypes) => set({ docTypes }),
  setPendencyTypes: (pendencyTypes) => set({ pendencyTypes }),
  setSuppliers: (suppliers) => set({ suppliers }),
  clearFilters: () => set({ regional: null, uf: null, docTypes: null, pendencyTypes: null, suppliers: null }),
  clearPendencyFilters: () => set({ pendencyTypes: null, suppliers: null }),
  
  // Helper para montar query params
  getFilterParams: () => {
    const state = get();
    const params: Record<string, string> = {};
    
    if (state.regional) params.regional = state.regional;
    if (state.uf) params.uf = state.uf;
    if (state.docTypes && state.docTypes.length > 0) {
      params.docTypes = state.docTypes.join(',');
    }
    if (state.pendencyTypes && state.pendencyTypes.length > 0) {
      params.pendencyTypes = state.pendencyTypes.join(',');
    }
    if (state.suppliers && state.suppliers.length > 0) {
      params.suppliers = state.suppliers.join(',');
    }
    
    return params;
  },
}));
